import {Component, Prop, Mixin} from "annotation";
import GField from './GField.vue'
import FormPropMixins from '../../../../util/mixin/FormProperties';

@Component()
export default class GFieldbody extends Mixin(FormPropMixins) {

	@Prop({default: '', type: String})
	public message: string;

	@Prop({default: false, type: Boolean})
	public isNarrow: boolean;

	public render(createElement: Function) {
		const {message, type, isNarrow, size, position, shape} = this;
		return createElement('div', {class: 'field-body'}, this.$slots.default.map((item: any) => {
			if (!item.tag) {
				return item
			}

			const attr = {props: {}};
			if (isNarrow) attr['class'] = 'is-narrow';

			// jika direct child > 1 dan merupakan komponen dgn tag dibawah,
			// apply props dibawah, dari dirinya ke komponen GField yg akan dibuat
			// dengan syarat $slots.default.length === 1
			if (typeof item.componentOptions === 'object') {
				const {tag, propsData} = item.componentOptions;

				if ((tag === 'g-input' || tag === 'g-select') && this.$slots.default.length > 1) {
					attr.props['label'] = propsData.label;
					attr.props['message'] = propsData.message;
					attr.props['type'] = propsData.type;
					attr.props['size'] = propsData.size;
				} else {
					attr.props = {message, type, isNarrow, size, position, shape};
				}
			}

			return createElement(GField, attr, [item]);
		}));
	}
}
